<template>
    <div class="col-lg-6  mb-3" :class="{'chart-loading': loading}">
        <h3 class="mb-3"><b>Tổng Điểm Rủi Ro Theo Mức Độ</b></h3>
        <Chart type="bar" :data="criteriaData" :options="basicOptions" :key="componentKey"/>
    </div>
</template>

<script>
import Chart from '@/components/Chart.vue';
export default {
    name: "chartCriteria",
    props:{
        criteria: Object,
        criteria_old: Object,
        criteria_old_old: Object,
        lables: Array,
        loading: Boolean
    },
    components: {
        Chart
    },
    watch: {
        "$props.lables"() {
            this.criteriaData.labels = this.lables ?? [];
        },
        "$props.criteria"() {
            if (this.criteria?.dataChart?.datasets && this.criteria.dataChart.datasets.length > 0) {
                this.criteria.dataChart.datasets.map((m, i) => {
                    if (this.criteriaData.datasets[i]) {
                        this.criteriaData.datasets[i].label = m?.label;
                        this.criteriaData.datasets[i].backgroundColor = m?.backgroundColor;
                        this.criteriaData.datasets[i].pointStyle = m?.pointStyle;
                        this.criteriaData.datasets[i].data[2] = m?.data ?? 0;
                        this.criteriaData.datasets[i].maxBarThickness = 32;
                    } else {
                        this.criteriaData.datasets[i] = {
                            label: m?.label,
                            backgroundColor: m?.backgroundColor,
                            pointStyle: m?.pointStyle,
                            data: [0, 0, m?.data ?? 0],
                            maxBarThickness: 32
                        }
                    }
                })
            }
            this.componentKey++;
        },
        "$props.criteria_old"() {
            if (this.criteria_old?.dataChart?.datasets && this.criteria_old.dataChart.datasets.length > 0) {
                this.criteria.dataChart.datasets.map((m, i) => {
                    if (this.criteriaData.datasets[i]) {
                        this.criteriaData.datasets[i].label = m?.label;
                        this.criteriaData.datasets[i].backgroundColor = m?.backgroundColor;
                        this.criteriaData.datasets[i].pointStyle = m?.pointStyle;
                        this.criteriaData.datasets[i].data[1] = m?.data ?? 0;
                        this.criteriaData.datasets[i].maxBarThickness = 32;
                    } else {
                        this.criteriaData.datasets[i] = {
                            label: m?.label,
                            backgroundColor: m?.backgroundColor,
                            pointStyle: m?.pointStyle,
                            data: [0, m?.data ?? 0, 0],
                            maxBarThickness: 32
                        }
                    }
                })
            }
            this.componentKey++;
        },
        "$props.criteria_old_old"() {
            if (this.criteria_old_old?.dataChart?.datasets && this.criteria_old_old.dataChart.datasets.length > 0) {
                this.criteria.dataChart.datasets.map((m, i) => {
                    if (this.criteriaData.datasets[i]) {
                        this.criteriaData.datasets[i].label = m?.label;
                        this.criteriaData.datasets[i].backgroundColor = m?.backgroundColor;
                        this.criteriaData.datasets[i].pointStyle = m?.pointStyle;
                        this.criteriaData.datasets[i].data[0] = m?.data ?? 0;
                        this.criteriaData.datasets[i].maxBarThickness = 32;
                    } else {
                        this.criteriaData.datasets[i] = {
                            label: m?.label,
                            backgroundColor: m?.backgroundColor,
                            pointStyle: m?.pointStyle,
                            data: [m?.data ?? 0, 0, 0],
                            maxBarThickness: 32
                        }
                    }
                })
            }
            this.componentKey++;
        }
    },
    data() {
        return {
            componentKey: 0,
            criteriaData: {
                // labels: ['2022', '2023', '2024'],
                maxBarThickness: 6,
                datasets: [
                    {
                        label: 'Cao',
                        backgroundColor: '#C00000',
                        pointStyle: 'rect',
                        data: [0, 0, 0]
                    },
                    {
                        label: 'Trung bình',
                        backgroundColor: '#E97131',
                        pointStyle: 'rect',
                        data: [0, 0, 0]
                    },
                    {
                        label: 'Thấp',
                        backgroundColor: '#3B7D22',
                        pointStyle: 'rect',
                        data: [0, 0, 0]
                    }
                ]
            },
            basicOptions: {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: '#495057'
                        },
                        position: 'bottom'
                    },
                    datalabels: {
                        color: '#000000',
                        anchor: 'end',
                        align: 'end',
                        clamp: true,
                        formatter: function(value) {
                            return String(value).replace(/(.)(?=(\d{3})+$)/g, "$1,");
                        }
                    }
                }
            }
        }
    }
}
</script>